/**
 * Optional `.env` overrides (`REACT_APP_*`). If unset, the committed defaults below are used.
 *
 * `REACT_APP_SOLANA_CONTRACT` — full base58 mint/CA string.
 * `REACT_APP_PUMP_FUN_URL` — e.g. `https://pump.fun/coin/...`
 * `REACT_APP_DEXSCREENER_URL` — pair or token URL on Dexscreener.
 */
const DEFAULT_SOLANA_CONTRACT = '9JLk12fG4sSW1RHatXRUEz7QHnjf4hwKu2jKaA15pump';
const DEFAULT_PUMP_FUN_URL =
  'https://pump.fun/coin/9JLk12fG4sSW1RHatXRUEz7QHnjf4hwKu2jKaA15pump';

export const SOLANA_CONTRACT_ADDRESS =
  process.env.REACT_APP_SOLANA_CONTRACT?.trim() || DEFAULT_SOLANA_CONTRACT;
export const PUMP_FUN_URL = process.env.REACT_APP_PUMP_FUN_URL?.trim() || DEFAULT_PUMP_FUN_URL;
export const DEXSCREENER_URL = process.env.REACT_APP_DEXSCREENER_URL || '';
